<button class="btn btn-{{ variant }} btn-{{ size }}" [disabled]="disabled" (click)="onClickButton($event)">
  <ng-content></ng-content>
</button>
